<!--
 * @Autor: haoyi
 * @LastEditors: haoyi
 * @LastEditTime: 2021-11-12 10:57:23
 * @Description: 视频模块1-领导专访(视频模块之间顺序改变,代码要变更)
-->
<template>
  <div id="module1" class="interview-live part">
    <div class="ele-title-live">
      <img
        src="https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/lvenav.png"
        alt
      />
    </div>
    <!-- 精彩直播 -->
    <div class="interview-live-wrapper">
      <div class="video-box">
        <swiper :options="swiperOptionLive" class="swiper-box">
          <swiper-slide
            v-for="(item, index) in liveList"
            :key="index"
            class="swiper-item swiper-no-swiping"
          >
            <a @click="goLiving(item.info6, item.info1)" class="coverLive">
              <span class="video-type">
                <img :src="item.info3" class="m-banner" alt="直播图片" />
                {{ item.info4 }}</span
              >
              <span class="people-look" v-if="item.info5 && item.info5 !== '0'"
                ><img
                  src="https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/huo.png"
                  class="m-banner"
                  alt="火"
                />{{ item.info5 }}人观看</span
              >
              <img
                class="live-img"
                style="background: black"
                :src="item.info2"
                alt="轮播"
              />
            </a>
            <div class="description">
              {{ item.info6 }}
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div
        v-show="liveList.length > 1"
        id="interviewPrevLive"
        class="swiper-button-prev swiper-button-white"
      ></div>
      <div
        v-show="liveList.length > 1"
        id="interviewNextLive"
        class="swiper-button-next swiper-button-white"
      ></div>
      <div
        id="interviewPaginationLive"
        slot="pagination"
        class="swiper-pagination"
        v-show="liveList.length > 1"
      ></div>
    </div>
  </div>
</template>
<script>
import XHR from '../api'
export default {
  name: 'liveVideo',
  props: {},
  data () {
    return {
      liveList: [],
      // 视频是否播放
      isPlay: false,
      playIndex: 0,
      playLink: '',
      // 视图窗口高度
      screenHeight: 0,
      swiperOptionLive: {
        autoplay: false,
        noSwiping: true,
        watchOverflow: true,
        navigation: {
          nextEl: '#interviewNextLive',
          prevEl: '#interviewPrevLive'
        },
        pagination: {
          el: '#interviewPaginationLive',
          clickable: false,
          renderBullet (index, className) {
            return `<span class="${className} swiper-pagination-bullet-custom"></span>`
          }
        },
        initialSlide: 0,
        observeParents: true,
        observer: true
      }
    }
  },
  mounted () {
    this.getBrightPoints()
  },
  methods: {
    goLiving (title, link) {
      const start = link.indexOf('liveId=') + 7
      // 防止后边有别的参数
      const end = link.indexOf('&') === -1 ? link.length : link.indexOf('&')
      this.setAnalytics('解放j6x|主页面|进入直播', link.substring(start, end))
      this.openUrl(title, link)
    },
    getBrightPoints () {
      XHR.getHandWork({
        type: 40,
        hid: 4891
      })
        .then(res => {
          const { status, data } = res.data
          if (!status) {
            this.liveList = data
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.ele-title-live {
  width: 100%;
  text-align: center;
  margin: 70px auto 30px;
}
.interview-live {
  width: 750px;
  margin: 0 auto 70px;
}
.interview-live {
  width: 100%;
  bottom: 28px;
  left: 0;
  .swiper-pagination {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 120px;
    left: 0;
    width: 100%;
    text-align: center;
  }
  /deep/.swiper-pagination-bullet {
    width: 72px;
    height: 2px;
    background: #02306a;
    opacity: 1;
    border-radius: 0;
    &.swiper-pagination-bullet-active {
      width: 72px;
      height: 2px;
      background: #fff;
    }
  }
}
.live-img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.interview-live-wrapper {
  width: 729px;
  height: 620px;
  background: url(https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/video-bg.png)
    no-repeat 50% 52px;
  // padding-top: 56px;
  box-sizing: border-box;
  margin: 33px auto 0;
  position: relative;
  .video-box {
    width: 620px;
    height: 100%;
    margin: 0 auto;
  }
  .swiper-item {
    width: 100%;
    .coverLive {
      width: 618px;
      height: 465px;
      border: 1px solid #52e5fe;
      position: relative;
      display: block;
      box-sizing: border-box;
      margin: 0 auto;
      cursor: pointer;
      .video-type {
        position: absolute;
        z-index: 100;
        font-size: 24px;
        color: #fff;
        margin-left: 5px;
        top: 24px;
        left: 24px;
        max-width: 190px;
        overflow: hidden;
        text-overflow: ellipsis;
        img {
          vertical-align: baseline;
        }
      }
      .people-look {
        position: absolute;
        z-index: 100;
        font-size: 24px;
        color: #fff;
        top: 24px;
        right: 24px;
        img {
          vertical-align: text-top;
          margin-right: 10px;
        }
      }
      .banner-img {
        display: block;
        width: 600px;
        height: 400px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
    .description {
      margin-top: 37px;
      font-size: 32px;
      color: #8be5ff;
      line-height: 42px;
      text-align: center;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      max-height: 80px;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 46px;
    height: 68px;
    background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/swiper-btn-prev.png')
      no-repeat 50% 50%;
    top: 223px;
    outline-style: none;
  }
  .swiper-button-prev {
    left: 3px;
  }
  .swiper-button-next {
    right: 3px;
    background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/swiper-btn-next.png')
      no-repeat 50% 50%;
  }
}
/deep/.ccH5PlayBtn {
  width: 42px;
  height: 62px;
  background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/video-btn-play.png')
    no-repeat 50% 50% !important;
}
</style>
